import { useEffect, useRef, useState } from "react";
import Grid, { GridColumn, GridHeader, GridRow } from "../../components/Grid/Grid";
import WebService from "../../utility/WebService";
import HelperService from "../../utility/HelperService";
import PageTitle from "../../components/PageTitle/PageTitle";
import { permissionsInterface } from "../onBoarding/onBoardingTypes";
import { useSelector } from "react-redux";
import { EyeFill, Pencil, Plus, Trash } from "react-bootstrap-icons";
import { toast } from "react-toastify";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import AddLoan from "./AddLoan";
import { Button } from "react-bootstrap";
import API from "../../utility/API-endPoints";
import ExpandableGrid, { ExpandableRow } from "../../components/Grid/ExpandableGrid";
import Select from "react-select";
import PlotDateRangePicker from "../../components/PlotDatePicker/PlotDateRangePicker";
import routePaths from "../../Navigation/routePaths";
import { useNavigate } from "react-router-dom";
import { PiExport } from "react-icons/pi";

const headers: GridHeader[] = [
    {
        title: "Project Name",
        class: "text-left",
        isSorting: false
    },
    {
        title: "Title",
        class: "text-left",
        isSorting: false
    },
    {
        title: "Payment Mode",
        class: "text-left",
        isSorting: false
    },
    {
        title: "Rate of Interest (Interest Type)",
        class: "text-left",
        isSorting: false
    },
    {
        title: "Loan Duration",
        class: "text-left",
        isSorting: false
    },
    {
        title: "Start-End Date",
        class: "text-left",
        isSorting: false
    },
    {
        title: "Paid Amount",
        class: "text-left",
        isSorting: false
    },
    {
        title: "Amount",
        class: "text-left",
        isSorting: false
    },
    {
        title: "Action",
        class: "text-center freeze-column",
        headerClass: "text-center",
        isSorting: false,
        isFilter: false,
        isFreeze: true,
    },
];

const Loan = () => {
    const navigate = useNavigate();
    const token = useSelector((state: any) => state.OnBoardingReducer);
    const nextOffset = useRef<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [rows, setRows] = useState<GridRow[]>([]);
    const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
    const [showDeleteModal, setDeleteModal] = useState<boolean>(false);
    const [showAddAgent, setShowAddAgent] = useState<boolean>(false);
    const [editData, setEditData] = useState<any>({});
    const [agentId, setAgentId] = useState<string>("");
    const [keyword, setKeyword] = useState<string>("");
    const [showHiddenFields, setShowHiddenFields] = useState<boolean>(false);
    const [pressedKeys, setPressedKeys] = useState(new Set());
    const [projectList, setProjectList] = useState<any[]>([]);
    const [isLoadingProject, setIsLoadingProject] = useState<boolean>(false);
    const [loanTypeList, setLoanTypeList] = useState<any[]>([{ value: "BANKING", label: "Banking" }, { value: "INDIVIDUAL", label: "Individual" }]);
    const [selectedProject, setSelectedProject] = useState<string>("");
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [selectedLoanType, setSelectedLoanType] = useState<string>("");
    const [totalCount, setTotalCount] = useState<number>(0);

    useEffect(() => {
        if (token && token.token && token.permissions && !!token.permissions.length) {
            setPermissions(token.permissions.find((item: any) => item.name === "INVENTORY"));
            !projectList.length && getProjectList();
        }
    }, [token]);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, [pressedKeys]);

    useEffect(() => {
        showHiddenFields && getLoanList(1);
    }, [showHiddenFields]);

    const getLoanList = (offset: number, keyword?: string) => {
        nextOffset.current = offset;
        if (nextOffset.current < 0 || isLoading) return;
        setIsLoading(true);
        WebService.getAPI({
            action: `${API.LOAN_LIST}?limit=10&offset=${offset ? offset - 1 : 0}&keyword=${keyword ? keyword : ""
                }&sort_by=asc&order_by=created_at&from_date=${startDate ? startDate : ""}&to_date=${endDate ? endDate : ""
                }&project_id=${selectedProject}&type=${selectedLoanType}`,
            body: null,
            is_session: showHiddenFields
        })
            .then((res: any) => {
                setIsLoading(false);
                let rows: GridRow[] = [];
                for (var i in res.list) {
                    let columns: GridColumn[] = [];
                    columns.push({ value: res.list[i]?.project ? res.list[i]?.project?.project_name : "N/A" });
                    columns.push({ value: res.list[i]?.title ? res.list[i]?.title : "N/A" });
                    columns.push({ value: res.list[i]?.payment_mode ? `${res.list[i]?.payment_mode} ${res.list[i]?.payment_mode === "CHEQUE" ? `(UTR No.:${res.list[i]?.utr_number})` : ""}` : "N/A" });
                    columns.push({ value: res.list[i]?.rate_of_interest ? `${res.list[i]?.rate_of_interest} (${HelperService.capitalizeFirstLetter(res.list[i]?.interest_type)})` : "N/A" });
                    columns.push({ value: res.list[i]?.loan_duration ? res.list[i]?.loan_duration : "N/A" });
                    columns.push({ value: (res.list[i]?.start_date && res.list[i]?.end_date) ? `${HelperService.getFormatedDate(res.list[i]?.start_date)} - ${HelperService.getFormatedDate(res.list[i]?.end_date)}` : "N/A" });
                    columns.push({ value: res.list[i].paid_amount ? HelperService.getCurrencyFormatter(res.list[i].paid_amount) : "N/A" });
                    columns.push({ value: res.list[i].amount ? HelperService.getCurrencyFormatter(res.list[i].amount) : "N/A" });
                    columns.push({ value: actionList(res.list[i]), type: "COMPONENT" });
                    rows.push({ data: columns });
                }
                setRows(rows);
                setKeyword(keyword ?? "");
                setTotalCount(res.count ?? 0);
            })
            .catch((e) => {
                setIsLoading(false);
            });
    };

    const onSortList = (offset: number) => { getLoanList(offset, null as any); };

    const actionList = (data: any) => {
        return (
            <div className="action-btns">
                {permissions && permissions.can_update && <button className="cursor-pointer  btn-edit btn" onClick={() => onEdit(data)}>{" "}<Pencil />{" "}</button>}
                {permissions && permissions.can_delete && <button onClick={() => onConfirmDelete(data)} className="cursor-pointer btn btn-delete">{" "}<Trash />{" "}</button>}
            </div>
        );
    };

    const onEdit = (val: any) => {
        setEditData(val);
        setShowAddAgent(true);
    };

    const onConfirmDelete = (val: any) => {
        setAgentId(val.uuid);
        setDeleteModal(true);
    };

    const onDelete = () => {
        setDeleteModal(false);
        setIsLoading(true);
        WebService.deleteAPI({
            action: `loan/delete/${agentId}`,
            body: null,
        })
            .then((res: any) => {
                setIsLoading(false);
                toast.success(res.message);
                setAgentId("");
                getLoanList(1);
            })
            .catch((e) => {
                setIsLoading(false);
                setAgentId("");
            });
    };

    const onCloseUserModal = (e: boolean) => {
        setShowAddAgent(false);
        setEditData({});
        e && getLoanList(1);
    };

    const exportLoan = () => {
        WebService.getAPI({
            action: `loan/export?keyword=${keyword ? keyword : ""}&sort_by=asc&order_by=created_at&from_date=${startDate ? startDate : ""}&to_date=${endDate ? endDate : ""}&project_id=${selectedProject}&type=${selectedLoanType}`,
            body: null,
            responseType: 'arraybuffer',
            is_session: showHiddenFields
        }).then((response: any) => {
            const url = window.URL.createObjectURL(new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `loans_${new Date().toISOString()}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }).catch((e) => { toast.error("Failed to export loans"); });
    };

    const handleKeyUp = (e: any) => {
        const key = e.key.toLowerCase();
        if (pressedKeys.has('control') && pressedKeys.has('alt') && pressedKeys.has('o') && pressedKeys.has('p')) setShowHiddenFields(true);
        setPressedKeys((prev: any) => { const updated = new Set(prev); updated.delete(key); return updated; });
    };

    const handleKeyDown = (e: any) => {
        const key = e.key.toLowerCase();
        setPressedKeys((prev: any) => new Set([...prev, key]));
    };

    const getProjectList = () => {
        setIsLoadingProject(true);
        WebService.getAPI({ action: "get/project/list" })
            .then((res: any) => {
                const defaultOption = [{ value: null, label: "Common" }];
                if (res.list && res.list.length > 0) {
                    res.list.forEach((item: any) => {
                        defaultOption.push({
                            ...item,
                            ...{ value: item.id, label: item.project_name },
                        });
                    })
                }
                setProjectList(defaultOption);
                setIsLoadingProject(false);
            })
            .catch((e: any) => { setIsLoadingProject(false); });
    };

    return (
        <>
            <AddLoan isShow={showAddAgent} isClose={(e: boolean) => { onCloseUserModal(e); }} data={editData} isRed={showHiddenFields} projectList={projectList} vendorList={loanTypeList} />
            <DeleteModal isShow={showDeleteModal} close={() => { setDeleteModal(false); }} onDelete={() => { onDelete(); }} />
            {permissions && permissions.can_read && <div className="app-page page-dashboard">
                <div className="d-flex justify-content-between align-items-center  mb-2"> <PageTitle title="Loans" backArrow={false} active={showHiddenFields} />
                    <div>
                        {permissions && permissions.can_write && <Button className="btn btn-brand-1" onClick={() => { setEditData({}); setShowAddAgent(true); }} >  <Plus size={20} className="ms-1" /> Add Loan </Button>}
                        {permissions && permissions.can_write && permissions.can_update && <Button className="btn btn-brand-1 ms-2" onClick={() => { exportLoan(); }} > <PiExport size={20} className="ms-1" /> Export Loan </Button>}
                    </div>
                </div>
                <div className="table-card">
                    {
                        <div className="row mb-3">
                            <div className="col-3">
                                <Select
                                    className="basic-single w-100"
                                    classNamePrefix="select"
                                    isSearchable={true}
                                    isClearable={true}
                                    options={projectList}
                                    onChange={(e: any) => { setSelectedProject(e ? e.value : ""); }}
                                    value={projectList?.find((option) => option.value === selectedProject)}
                                    placeholder="Select Project"
                                />
                            </div>
                            <div className="col-3">
                                <Select
                                    className="basic-single w-100"
                                    classNamePrefix="select"
                                    isSearchable={true}
                                    isClearable={true}
                                    options={loanTypeList}
                                    onChange={(e: any) => { setSelectedLoanType(e ? e.value : ""); }}
                                    value={loanTypeList?.find((option) => option.value === selectedLoanType)}
                                    placeholder="Select Type"
                                />
                            </div>
                            <div className="col-3">
                                <PlotDateRangePicker start_date={startDate} end_date={endDate} onDateChange={(start_date, end_date) => { setStartDate(start_date); setEndDate(end_date); }} />
                            </div>
                            <div className="col-3"> <Button className="btn-brand-1" onClick={() => { getLoanList(1) }} >  Search </Button>  </div>
                        </div>
                    }
                    <Grid
                        rows={rows}
                        headers={headers}
                        showDateFilter={false}
                        onPageChange={getLoanList}
                        errorMessage={"No Loan Found"}
                        ShowLoader={isLoading}
                        onSort={onSortList}
                        count={totalCount}
                    />
                </div>
            </div>}
        </>
    );
};

export default Loan;